import { Contract } from "./contract";

export class ContractDetail {
    id?: string;
    contract?: Contract | null;
    isCreationMode?: boolean;
    isEditMode?: boolean;
    isReadOnlyMode?: boolean;
    constructor(contractDetail?: ContractDetail) {
        this.id = contractDetail?.id;
        this.contract = contractDetail?.contract;
        this.isCreationMode = contractDetail?.isCreationMode || false;
        this.isEditMode = contractDetail?.isEditMode || false;
        this.isReadOnlyMode = contractDetail?.isReadOnlyMode || false;
    }
}
